import { useEffect, useState } from 'react';
import { initialQueryState, KTSVG } from '../../_metronic/helpers';
import { useQueryRequest } from './request';
import { useQueryResponse } from './response';
import { useSearchParams } from 'react-router-dom';

/**
 * FilterKycRequest Component
 * Renders a dropdown filter for KYC request types (PAN, Bank, Web Bank).
 * Handles filter state, reset, and apply actions, updating query state and search params.
 * Integrates with loading state and provides UI for selecting and applying filters.
 */
const FilterKycRequest = () => {
    const { updateState } = useQueryRequest();
    const { isLoading } = useQueryResponse();
    const [request_type, setRequestType] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    useEffect(() => {

        const request_type = searchParams.get('request_type');

        if (request_type) setRequestType(request_type);
        updateState({
            filter: { request_type },
            ...initialQueryState,
        });

    }, []);


    // Reset filter data
    const resetData = () => {
        setRequestType('register_user_pan');
        updateState({ filter: 'register_user_pan', ...initialQueryState });
        setSearchParams({ request_type: 'register_user_pan' });
    };

    // Apply filter data
    const filterData = () => {
        setSearchParams({ request_type });
        updateState({
            filter: { request_type },
            ...initialQueryState,
        });
    };

    // Constants for dropdown options
    const dropdownOptions = [
        { value: 'register_user_pan', label: 'Register Pan Request' },
        { value: 'register_user_bank', label: 'Register Bank Request' },
        { value: 'pan_card', label: 'Web Bank Request' },
    ];

    return (
        <>
            <button
                disabled={isLoading}
                type="button"
                className="btn btn-light-primary me-3"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
            >
                <KTSVG path="/media/icons/duotune/general/gen031.svg" className="svg-icon-2" />
                Filter
            </button>
            <div className="menu menu-sub menu-sub-dropdown w-300px w-md-325px" data-kt-menu="true">
                <div className="px-7 py-5">
                    <div className="fs-5 text-dark fw-semibolder">Filter Options</div>
                </div>
                <div className="separator border-gray-200"></div>
                <div className="px-7 py-5" data-kt-user-table-filter="form">
                    <div className="mb-4">
                        <label className="form-label fs-5 fw-semibold">Select Request Type:</label>
                        <select
                            className="form-select form-select-sm form-select-solid fs-6"
                            onChange={(e) => setRequestType(e.target.value)}
                            value={request_type}
                        >
                            <option value="">Select</option>
                            {dropdownOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="d-flex justify-content-end pt-4">
                        <button
                            type="button"
                            disabled={isLoading}
                            onClick={resetData}
                            className="btn btn-light btn-active-light-primary fw-semibold me-2 px-6"
                            data-kt-menu-dismiss="true"
                        >
                            Reset
                        </button>
                        <button
                            disabled={isLoading}
                            type="button"
                            onClick={filterData}
                            className="btn btn-primary fw-semibold px-6"
                            data-kt-menu-dismiss="true"
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export { FilterKycRequest };
